import { AxiosInstance } from 'axios'

export interface DeleteProjectParams {
  projectId: string
}

export const deleteProject = async (
  apiClient: AxiosInstance,
  params: DeleteProjectParams
) => {
  const { data: axiosData } = await apiClient.delete(
    `/api/project-info/${params.projectId}`
  )
  return axiosData.data
}
